import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/core/global-store';

export default function OwnerTopBar() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const user = useAppSelector((state) => state.auth.me);
    const currentLang = i18n.language?.startsWith('ar') ? 'ar' : 'en';
    const nextLang = currentLang === 'ar' ? 'en' : 'ar';

    const switchLang = () => {
        Cookies.remove('i18next');
        Cookies.remove('i18nextLng');
        localStorage.removeItem('i18nextLng');
        Cookies.set('i18nextLng', nextLang, { expires: 365 });
        localStorage.setItem('i18nextLng', nextLang);
        document.documentElement.dir = nextLang === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = nextLang;

        const stripped = location.pathname.replace(/^\/(ar|en)(?=\/|$)/, '') || '/';
        const nextPath = `/${nextLang}${stripped === '/' ? '/control-plane/overview' : stripped}`;
        i18n.changeLanguage(nextLang).finally(() => navigate(nextPath));
    };

    return (
        <div className="sticky top-0 z-30 flex h-12 items-center justify-between border-b border-slate-200 bg-white/95 px-4 backdrop-blur">
            <div className="text-sm font-semibold text-slate-900">{t('controlPlane.shellEyebrow')}</div>
            <div className="flex items-center gap-3">
                <span className="hidden max-w-[12rem] truncate text-xs text-slate-500 sm:inline">
                    {user?.data?.email || user?.data?.name}
                </span>
                <button
                    type="button"
                    onClick={switchLang}
                    className="cursor-pointer rounded-md border border-slate-200 px-2.5 py-1 text-xs font-semibold uppercase text-slate-700 hover:border-sky-400 hover:text-sky-800"
                >
                    {nextLang}
                </button>
            </div>
        </div>
    );
}
